import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import usePageMeta from "@/lib/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "Siden findes ikke (404)",
    description: "Den side, du leder efter, findes ikke. Gå tilbage til forsiden eller kontakt os.",
    noindex: true,
  });

  return (
    <div className="min-h-[80svh] flex items-center justify-center px-6 py-32" data-testid="not-found-page">
      <div className="max-w-2xl text-center">
        <p className="text-xs uppercase tracking-label text-accent mb-6">404</p>
        <h1 className="font-display text-5xl md:text-7xl font-light leading-tight">Siden findes ikke</h1>
        <p className="mt-6 text-muted-foreground font-light text-lg">
          Vi kunne ikke finde det, du ledte efter. Måske er linket forældet, eller siden er flyttet.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            data-testid="notfound-home"
            className="group inline-flex items-center gap-3 bg-foreground text-background px-8 py-4 text-xs uppercase tracking-label font-semibold hover:bg-accent transition-colors"
          >
            Tilbage til forsiden
            <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-3 border border-foreground/50 text-foreground px-8 py-4 text-xs uppercase tracking-label font-semibold hover:bg-foreground hover:text-background transition-colors"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
